<template>
  <div class="ac-root">
    <div class="ac-card">
      <div class="ac-logo">Abitué</div>

      <!-- A verificar token -->
      <div v-if="estado === 'verificando'" class="ac-loading">
        <span class="ac-spinner"></span>
        A verificar o teu convite…
      </div>

      <!-- Token inválido / expirado -->
      <div v-else-if="estado === 'invalido'" class="ac-erro">
        <div class="ac-icon">❌</div>
        <h2>Convite inválido</h2>
        <p>{{ mensagemErro }}</p>
        <p>
          Se precisas de acesso, pede ao teu administrador que envie um novo
          convite.
        </p>
      </div>

      <!-- Formulário de registo -->
      <div v-else-if="estado === 'form'">
        <h2 class="ac-titulo">Bem-vindo à equipa!</h2>
        <p class="ac-sub">
          <strong>{{ nomeOwner }}</strong> convidou-te para o painel Abitué.<br />
          Define o teu nome e password para activar a tua conta.
        </p>

        <div class="ac-field">
          <label>O teu nome</label>
          <input
            v-model="nome"
            type="text"
            placeholder="Ex: João Silva"
            class="ac-input"
          />
        </div>

        <div class="ac-field">
          <label>Email</label>
          <input
            :value="email"
            type="email"
            class="ac-input ac-input-disabled"
            disabled
          />
        </div>

        <div class="ac-field">
          <label>Password (mínimo 6 caracteres)</label>
          <input
            v-model="password"
            type="password"
            placeholder="••••••••"
            class="ac-input"
            @keyup.enter="submeter"
          />
        </div>

        <p v-if="erroForm" class="ac-error-text">{{ erroForm }}</p>

        <button class="ac-btn" :disabled="submetendo" @click="submeter">
          {{ submetendo ? "A criar conta…" : "Criar conta e entrar" }}
        </button>
      </div>

      <!-- Sucesso -->
      <div v-else-if="estado === 'sucesso'" class="ac-sucesso">
        <h2>Conta criada!</h2>
        <p>A tua conta foi criada com sucesso. Podes agora fazer login.</p>
        <button class="ac-btn" @click="$router.push('/login')">
          Ir para o login
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "@/api/index.js";

  export default {
    name: "AceitarConvite",

    data() {
      return {
        estado: "verificando", // verificando | invalido | form | sucesso
        token: "",
        email: "",
        nomeOwner: "",
        nome: "",
        password: "",
        erroForm: "",
        mensagemErro: "",
        submetendo: false,
      };
    },

    mounted() {
      this.token = this.$route.query.token || "";
      if (!this.token) {
        this.estado = "invalido";
        this.mensagemErro = "Link de convite em falta.";
        return;
      }
      this.verificarToken();
    },

    methods: {
      async verificarToken() {
        try {
          const { data } = await api.get(`/staff/convite/${this.token}`);
          this.email = data.email;
          this.nomeOwner = data.nomeOwner;
          this.estado = "form";
        } catch (err) {
          this.estado = "invalido";
          this.mensagemErro =
            err.response?.data?.error || "Convite inválido ou expirado.";
        }
      },

      async submeter() {
        this.erroForm = "";
        if (!this.nome.trim()) {
          this.erroForm = "O nome é obrigatório.";
          return;
        }
        if (this.password.length < 6) {
          this.erroForm = "A password deve ter pelo menos 6 caracteres.";
          return;
        }

        this.submetendo = true;
        try {
          await api.post("/staff/aceitar-convite", {
            token: this.token,
            nome: this.nome.trim(),
            password: this.password,
          });
          this.estado = "sucesso";
        } catch (err) {
          this.erroForm = err.response?.data?.error || "Erro ao criar conta.";
        } finally {
          this.submetendo = false;
        }
      },
    },
  };
</script>

<style scoped>
  .ac-root {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #faf8f6;
    padding: 24px;
  }
  .ac-card {
    background: #fff;
    border-radius: 24px;
    padding: 40px 36px;
    max-width: 440px;
    width: 100%;
    box-shadow: 0 4px 32px rgba(0, 0, 0, 0.08);
  }
  .ac-logo {
    font-size: 22px;
    font-weight: 800;
    color: #1a1210;
    margin-bottom: 28px;
  }
  .ac-titulo {
    font-size: 22px;
    font-weight: 700;
    color: #1a1210;
    margin-bottom: 8px;
  }
  .ac-sub {
    font-size: 14px;
    color: #6b6460;
    margin-bottom: 28px;
    line-height: 1.5;
  }

  .ac-field {
    margin-bottom: 16px;
  }
  .ac-field label {
    display: block;
    font-size: 12px;
    font-weight: 700;
    color: #6b6460;
    margin-bottom: 6px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
  }
  .ac-input {
    width: 100%;
    box-sizing: border-box;
    border: 1.5px solid #e8e4e1;
    border-radius: 12px;
    padding: 10px 14px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.15s;
  }
  .ac-input:focus {
    border-color: #ff825d;
  }
  .ac-input-disabled {
    background: #f5f3f1;
    color: #8a7f7a;
    cursor: not-allowed;
  }

  .ac-btn {
    width: 100%;
    background: #ff825d;
    color: #fff;
    border: none;
    border-radius: 30px;
    padding: 13px;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    margin-top: 8px;
    transition: opacity 0.15s;
  }
  .ac-btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
  .ac-btn:hover:not(:disabled) {
    opacity: 0.85;
  }

  .ac-error-text {
    color: #e74c3c;
    font-size: 13px;
    margin-bottom: 8px;
  }

  .ac-loading {
    display: flex;
    align-items: center;
    gap: 12px;
    justify-content: center;
    padding: 32px 0;
    color: #8a7f7a;
    font-size: 14px;
  }
  .ac-spinner {
    width: 18px;
    height: 18px;
    border: 2.5px solid #f0ece9;
    border-top-color: #ff825d;
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
  }
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .ac-erro,
  .ac-sucesso {
    text-align: center;
    padding: 16px 0;
  }
  .ac-icon {
    font-size: 40px;
    margin-bottom: 16px;
  }
  .ac-erro h2,
  .ac-sucesso h2 {
    font-size: 20px;
    font-weight: 700;
    color: #1a1210;
    margin-bottom: 8px;
  }
  .ac-erro p,
  .ac-sucesso p {
    color: #6b6460;
    font-size: 14px;
    margin-bottom: 8px;
    line-height: 1.5;
  }
</style>
